import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[noPrint]',
    standalone: false
})
export class NoPrintDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'no-print');
  }

}
